export interface AuthState {
  authenticated: boolean;
  username: string | null;
}

export async function fetchAuthState(): Promise<AuthState> {
  const res = await fetch("/api/auth/me", {
    headers: { "X-FlareDrive-Client": "web" },
  });
  if (!res.ok) return { authenticated: false, username: null };
  return (await res.json()) as AuthState;
}

export async function login(username: string, password: string) {
  const res = await fetch("/api/auth/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-FlareDrive-Client": "web",
    },
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? "Sign-in failed");
  }
  return (await res.json()) as { ok: true; username: string };
}

export async function logout() {
  await fetch("/api/auth/logout", {
    method: "POST",
    headers: { "X-FlareDrive-Client": "web" },
  });
}
